import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10 40h28v-4H10zm28-22h-8V6H18v12h-8l14 14z" })
});
export default SvgDownload;
